import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import api from "../services/axios";
import { queryClient } from "../services/queryClient";
import ApiCall from "../services/apiCall";

export const usePost = ({ url, onSuccess, onError }) => {
  const postApi = async (payload = {}) => {
    const token = localStorage.getItem("userToken");
    const jsonToken = JSON.parse(token);
    if (jsonToken) {
      api.defaults.headers.common["Authorization"] = `Bearer ${jsonToken}`;
    }

    const response = await api.post(url, payload);
    return response.data;
  };

  return useMutation({
    mutationFn: postApi,
    onSuccess: (data) => {
      onSuccess && onSuccess(data);
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      handleErrors(error);
      onError && onError(error);
    },
  });
};

export const usePostFile = ({ url, onSuccess, onError }) => {
  const postApi = async (payload = {}) => {
    const token = localStorage.getItem("userToken");
    const jsonToken = JSON.parse(token);
    if (jsonToken) {
      api.defaults.headers.common["Authorization"] = `Bearer ${jsonToken}`;
    }
    // api.defaults.headers.common['Content-Type'] = 'multipart/form-data';
    const response = await api.post(url, payload);
    return response.data;
  };

  return useMutation({
    mutationFn: postApi,
    onSuccess: (data) => {
      onSuccess && onSuccess(data);
    },
    onError: (error) => {
      handleErrors(error);
      onError && onError(error);
    },
  });
};

export const handleLogOut = async () => {
  try {
    const res = await ApiCall("api/logout", "POST", undefined);
    if (res.ok == true) {
      if (res?.message || res?.data?.message) {
        toast.success(res?.message || res?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
      localStorage.removeItem("userToken");
      localStorage.removeItem("userData");
      queryClient.invalidateQueries();
    }
  } catch (error) {
    toast.error(error?.message);
  }
};

const handleErrors = ({ response, message }) => {
  let errorMessage;

  if (response?.data?.message) {
    errorMessage = response.data.message;
  } else if (response?.data?.error) {
    errorMessage = Object.values(response.data.errors)[0];
  } else if (message) {
    errorMessage = message;
  }

  console.error("error response", JSON.stringify(errorMessage));
  console.error("error response", JSON.stringify(response?.data));

  if (errorMessage === "jwt expired") {
    toast.error("Session expired - please login again");
    // TODO: add logout function
  } else {
    toast.error(errorMessage);
  }
};
